import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

import { FUTURE, PAST_YEAR, PRESENT, TIMELINE_PATHNAME } from 'timeline/enums/constants';
import { getTimelineTimePeriod } from 'timeline/utils/getTimelineTimePeriod';
import { parseSeasonYear } from 'shared/utils/getYear';

dayjs.extend(customParseFormat);

export const getGridReleaseDateDisplay = (
  releaseDate: number,
  season: string,
  { query, asPath, pathname },
) => {
  const timelineTimePeriod = getTimelineTimePeriod({ asPath, query, pathname });

  const parseFormat = 'YYYYMMDD';
  const formattedDate = dayjs(`${releaseDate}`, parseFormat);

  if (season && pathname !== TIMELINE_PATHNAME) {
    return parseSeasonYear(season);
  }

  if (formattedDate.format('MMM DD YYYY') === 'Invalid Date') {
    return '';
  }

  if (timelineTimePeriod === PAST_YEAR) {
    return formattedDate.format('MMM DD');
  }

  if (timelineTimePeriod === FUTURE || timelineTimePeriod === PRESENT) {
    return formattedDate.format('MMM DD YYYY');
  }

  const currentYear = dayjs().year().toString();
  return currentYear === formattedDate.format('YYYY')
    ? formattedDate.format('MMM DD')
    : formattedDate.format('YYYY');
};
